import { initialConfig, provideEnvironmentNgxMask } from 'ngx-mask';

export const provideAppNgxMask = () =>
  provideEnvironmentNgxMask({
    validation: false,
    patterns: {
      ...initialConfig.patterns,
      Z: { pattern: /[A-Za-z0-9]/, optional: true },
    },
  });
